export default "__VITE_ASSET__ChQZ01Tg__"